// src/redux/apiSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { Console } from "console";
import { hydrate } from "react-dom";
import { PERSIST, PURGE, REHYDRATE } from "redux-persist";
import { fetchDashboardInfoForUserId } from "./dashboardForUserId";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
export let id: number = 0;

export let dashboardMenu: any = {
  dashboards: {
    id: "dashboards",
    text: "Dashboards",
    path: "/dashboard",
    icon: "CustomDashboard",
    subMenu: {},
  },
};
const initialDashboardMenuState = {
  dashboards: {
    id: "dashboards",
    text: "Dashboards",
    path: "/dashboard",
    icon: "CustomDashboard",
    subMenu: {},
  },
};

export let tabs: any = {};

interface ApiState {
  data: any; // You can define a more specific type here
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: ApiState = {
  data: [],
  status: "idle",
  error: null,
};

// Define a thunk to fetch data
export const fetchAllDashboardsData = createAsyncThunk(
  "api/fetchDashboardsData",
  async (endpoint: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(endpoint, {
      headers: { Authorization: "Bearer " + token },
    });
    for (let dat of response.data.obj) {
      let menu = { id: dat.id, text: dat.name, path: "/dashboard" };
      dashboardMenu.dashboards.subMenu[dat.name] = menu;
      if (dat.isDefault === true) {
        id = dat.id;
      }
    }
    console.log(dashboardMenu);
    return response.data;
  }
);

const apiSlice = createSlice({
  name: "apiDashboard",
  initialState,
  reducers: {
    // This action will reset the slice's state to its initial value.
    resetApiState: () => initialState,
    // This action will reset the external `dashboardMenu` variable.
    clearDashboardMenu: () => {
      dashboardMenu = JSON.parse(JSON.stringify(initialDashboardMenuState));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllDashboardsData.pending, (state) => {
        console.log("==1==");

        state.status = "loading";
      })
      .addCase(
        fetchAllDashboardsData.fulfilled,
        (state, action: PayloadAction<any>) => {
          console.log(action);
          console.log("==2==");
          if (action.type === "api/fetchDashboardsData/fulfilled")
            state.status = "succeeded";
          state.data = action.payload;
        }
      )
      .addCase(fetchAllDashboardsData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "Failed to fetch data";
        console.log("==3==");
      })
      .addCase(REHYDRATE, (state, action: any) => {
        console.log("==4==", action.payload);

        if (
          action.payload === undefined ||
          action.payload?.apiDashboard.status === "idle"
        ) {
          console.log("There is no data in the dashboard");
        } else {
          const response = action.payload?.apiDashboard;
          console.log(
            "Response in apiSlice:",
            action.payload?.apiDashboardForUserId.dashboardData
          );
          for (let dat of response?.data.obj) {
            console.log(" dat.isDefault", dat.id);
            let menu = {
              id: dat.id,
              text: dat.name,
              path: "/dashboard",
              default: dat.isDefault,
            };
            dashboardMenu.dashboards.subMenu[dat.name] = menu;
          }
        }

        // state.data = action.payload.apiDashboard.data;
      });
  },
});
export const { resetApiState, clearDashboardMenu } = apiSlice.actions;

export default apiSlice.reducer;
